import { ERROR_CODE } from '../constants';

export default {
  shared: {
    lib: {
      keycloak: {
        error: {
          [ERROR_CODE.invalid_grant]: 'Неверные логин или пароль, либо истёк срок действия токена.',
          [ERROR_CODE.invalid_request]: 'Неверный запрос. Проверьте правильность отправленных данных.',
          [ERROR_CODE.unsupported_grant_type]: 'Тип авторизации не поддерживается.',
          [ERROR_CODE.invalid_scope]: 'Запрошенная область (scope) недопустима.',
          [ERROR_CODE.unauthorized_client]: 'Клиент не авторизован для выполнения этого действия.',
        },
        defaultError: '[FE] Неизвестная ошибка',
      },
    },
  },
};
